import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React from "react";
import { Message } from "components/Atoms/Message";
import { ButtonPrimary } from "components/Atoms/Button";
import moment from "moment";
import { ReactivateUserForInternalModal } from "UserAdmin/UserForInternalAdmin/ReactivateUserForInternalModal";
import { ReactivateUserForExternalModal } from "UserAdmin/UserForExternalAdmin/ReactivateUserForExternalModal";

interface Props {
  userToClient: server.dto.UserForInternalAdmin | server.dto.UserForExternalAdmin;
  title: string;
  environment: server.dto.Environments;
}

export const DeactivatedUserDetailSection = (props: Props) => {
  const [isReactivateModalOpen, setIsReactivateModalOpen] = React.useState<boolean>(false);

  return <>
    <DetailSectionTemplate
      isInPageEditable={false}
      onValueChanged={() => { }}
      sections={[{
        key: "user",
        type: "regular",
        title: props.title,
        fields: [{
          key: "lastActivity",
          label: RESX.SoUser.LastActivity,
          render: () => props.userToClient.lastActivityUtc === null ? RESX.SoUser.NeverLoggedOn : moment(props.userToClient.lastActivityUtc).fromNow(),
        }, {
          key: "status",
          label: RESX.Status.resxStatus,
          render: () => <Message type="error">
            {RESX.SoUser.Deactivated}
          </Message>
        }, {
          key: "username",
          label: RESX.SoUser.Username,
          render: () => props.userToClient.username,
        }, {
          key: "reactivate",
          label: "",
          hideLabel: true,
          render: () => <div className="flex justify-end">
            <ButtonPrimary
              label={RESX.SoUser.ReactivateAccount}
              onClick={() => setIsReactivateModalOpen(true)}
            />
          </div>
        }]
      }]}
    />
    {props.environment === "internal" ?
      <ReactivateUserForInternalModal
        isOpen={isReactivateModalOpen}
        userToClient={props.userToClient}
        onClose={() => setIsReactivateModalOpen(false)}
      /> :
      <ReactivateUserForExternalModal
        isOpen={isReactivateModalOpen}
        userToClient={props.userToClient}
        onClose={() => setIsReactivateModalOpen(false)}
      />}
  </>
}